import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GAMES_FEATURE_KEY, GamesState } from './games.reducer';

// Lookup the 'Games' feature state managed by NgRx
export const getGamesState =
  createFeatureSelector<GamesState>(GAMES_FEATURE_KEY);

export const getGamesLoaded = createSelector(
  getGamesState,
  (state: GamesState) => state.loaded,
);

export const getGamesFilteringState = createSelector(
  getGamesState,
  (state: GamesState) => state.filtering,
);

export const getMoreGamesLoaded = createSelector(
  getGamesState,
  (state: GamesState) => state.loadedMore,
);

export const getGamesError = createSelector(
  getGamesState,
  (state: GamesState) => state.error,
);

export const getMoreGamesError = createSelector(
  getGamesState,
  (state: GamesState) => state.errorMore,
);

export const getAllResponse = createSelector(
  getGamesState,
  (state: GamesState) => state,
);

export const getAllGames = createSelector(
  getGamesState,
  (state: GamesState) => state.entities,
);

export const getGamesTotal = createSelector(
  getGamesState,
  (state: GamesState) => state.total,
);

export const getGamesEntities = createSelector(
  getGamesState,
  (state: GamesState) => state.entities,
);

export const getSelectedId = createSelector(
  getGamesState,
  (state: GamesState) => state.selectedId,
);

export const isAllLoaded = createSelector(
  getGamesState,
  (state: GamesState) => state.allLoaded,
);

export const getPaginationResponse = createSelector(
  getGamesState,
  (state: GamesState) => ({
    pageIndex: state.pageIndex,
    pageSize: state.pageSize,
    total: state.total,
  }),
);

export const getSearchTerm = createSelector(
  getGamesState,
  (state: GamesState): string => state.searchTerm || '',
);

export const getTags = createSelector(
  getAllResponse,
  ({ filters }) => filters.gameTags,
);

// get the selected tags from the games

export const getGameSelectedTags = createSelector(
  getGamesState,
  (state: GamesState): string[] => state.filterByTags || [],
);
